<template>
    <div class="h-100 bg-white p-3" style="border-radius: 20px">
        <div class="d-flex">
            <div class="mr-2">
                <div :style="`align-items: center; justify-content: center; display: flex; height: 47px; width: 47px; background-color: ${iconBgColor}; border-radius: 10px`">
                    <img :src="require(`@/assets/images/statistics/icons/${icon}`)"/>
                </div>
            </div>
            <div class="d-flex flex-column flex-fill">
                <p class="mb-0" style="font-family: MainFontRegular, sans-serif">{{ title }}</p>

            <p class="h4" style="font-family: MainFontBold, sans-serif;">  {{ value }}</p>
            </div>
        </div>

        <div class="d-flex" v-if="note">
            <svg width="25" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.00005 0.800003C11.978 0.800003 15.2 4.022 15.2 8C15.2 11.978 11.978 15.2 8.00005 15.2C4.02205 15.2 0.800049 11.978 0.800049 8C0.800049 4.022 4.02205 0.800003 8.00005 0.800003ZM8.90005 4.4C8.90005 3.905 8.49505 3.5 8.00005 3.5C7.50505 3.5 7.10005 3.905 7.10005 4.4C7.10005 4.895 7.50505 5.3 8.00005 5.3C8.49505 5.3 8.90005 4.895 8.90005 4.4ZM8.90005 12.5V7.1H7.10005V12.5H8.90005Z" fill="#87929D"/>
            </svg>
            <p class="ml-2 mb-0" style="font-size: 11px; color: #87929D; line-height: 14px;">
                {{ note }}
            </p>
        </div>


    </div>
</template>

<script>
export default {
    name: "StatCard",
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: String|Number,
            required: true
        },
        note: {
            type: String
        },
        icon: {
            type: String,
            required: true
        },
        iconBgColor: {
            type: String,
            required: true
        },
    }
};
</script>
